<div id="shopCart" class="cart-icon" [ngClass]="{'cart-icon-fixed': iconPositionType === 'site'}" *ngIf="shopEnabled" (click)="cartIconClick()">
    <div class="cart-icon-wrapper" [ngStyle]="getIconStyles()">
        <span class="icon-counter" [ngStyle]="getCounterStyles()" *ngIf="this.isPreview">1</span>
        <span class="icon-counter" [ngStyle]="getCounterStyles()" *ngIf="(cartNumberOfItems$ | async) > 0">{{ cartNumberOfItems$ | async }}</span>
        <div [innerHTML]="getIcon()" [ngStyle]="previewIconSizeStyle()" class="icon"></div>
        <div class="hint-container">
            <span *ngIf="(cartNumberOfItems$ | async) > 0; else empty">{{ 'go_to_cart_hint' | translate }}</span>
            <ng-template #empty>{{ 'empty_cart_hint' | translate }}</ng-template>
        </div>
    </div>
</div>
